import { useEffect, useState } from "react";
import { MapPin, Clock, MessageCircle, Scissors } from "lucide-react";
import { api } from "@/lib/api";
import { buildWhatsappLink, genericInquiryMessage } from "@/lib/whatsapp";

export default function StoreFitting() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  const waLink = buildWhatsappLink(settings?.whatsapp_number || "", genericInquiryMessage());
  const hasAddress = !!settings?.store_address;
  const hasHours = !!settings?.store_hours;

  return (
    <section id="anprobe" data-testid="store-fitting" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="relative aspect-[4/3] md:aspect-[5/4] overflow-hidden bg-white border border-[#E5E0D8]">
          <img
            src="https://customer-assets.emergentagent.com/wingman/0d2804ce-7e74-4278-b556-2221bc03102d/attachments/e236f421792945288474a5fbc5434b65_7839907F-13A9-401B-B8B0-1F93E9D20A3B.png"
            alt="EXTRA Änderungsschneiderei"
            className="w-full h-full object-contain"
          />
        </div>

        <div>
          <div className="overline mb-4"><span className="gold-line" />Anprobe & Anpassung inklusive</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
            Anprobe im Laden – inklusive kostenloser Anpassung.
          </h2>
          <p className="mt-6 text-ink/75 leading-relaxed text-lg font-light max-w-lg">
            Unsere Kleider werden in unserem eigenen Schneider-Atelier gelagert und gepflegt.
            Bei der Anprobe nehmen wir Maß und passen dein Kleid individuell an dich an –
            Länge, Weite und kleine Anpassungen sind <strong className="text-ink">vollständig im Mietpreis enthalten</strong>.
          </p>

          <div className="mt-8 flex items-start gap-4 p-5 border border-gold/40 bg-white">
            <Scissors className="text-gold mt-1 shrink-0" size={20} />
            <div>
              <div className="overline text-gold">Kostenlos inklusive</div>
              <div className="mt-1 text-ink/85">
                Individuelle Anpassungen durch unsere hauseigenen Schneider – damit das Kleid sitzt wie maßgeschneidert.
              </div>
            </div>
          </div>

          {(hasAddress || hasHours) && (
            <div className="mt-8 grid sm:grid-cols-2 gap-6">
              {hasAddress && (
                <div className="flex items-start gap-3">
                  <MapPin className="text-gold mt-1" size={18} />
                  <div>
                    <div className="overline">Adresse</div>
                    <div className="text-sm text-ink/80 mt-1">{settings.store_address}</div>
                  </div>
                </div>
              )}
              {hasHours && (
                <div className="flex items-start gap-3">
                  <Clock className="text-gold mt-1" size={18} />
                  <div>
                    <div className="overline">Öffnungszeiten</div>
                    <div className="text-sm text-ink/80 mt-1">{settings.store_hours}</div>
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <a
              data-testid="store-whatsapp"
              href={waLink}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white px-8 py-4 text-xs tracking-widest uppercase hover:bg-[#1EBE57] transition-colors duration-300 shadow-sm"
            >
              <MessageCircle size={16} /> Termin per WhatsApp
            </a>
            <a
              href="#anfrage"
              className="inline-flex items-center justify-center border border-ink text-ink px-8 py-4 text-xs tracking-widest uppercase hover:bg-ink hover:text-cream transition-colors"
            >
              Anfrage senden
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
